<!--用户管理新建档案详情页面-->
<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail" :colon="false">
        <a-tabs v-model="activeKey" @change="callback">
          <a-tab-pane key="1" :tab="$t('用户详细信息')">
            <div>
              <span style="font-size:16px">{{ $t('当前用户状态') }}:</span>
              <a-button
                :class="queryUserDetailInfoById.userState == 1?'normalbg-status':queryUserDetailInfoById.userState == 0?'unactivebg-status':''"
                style="margin-left:18px">
                {{queryUserDetailInfoById.userState==1?$t('已激活'):queryUserDetailInfoById.userState==0?$t('未激活'):''}}
              </a-button>
            </div>
            <div class="form-contain">
              <a-divider orientation="left">
                {{ $t('用户信息') }}
              </a-divider>
              <detail-list :col="4">
                <detail-list-item :term="$t('用户姓名')">{{queryUserDetailInfoById.userName}}</detail-list-item>
                <detail-list-item :term="$t('用户编号')">{{queryUserDetailInfoById.userId}}</detail-list-item>
                <!-- <detail-list-item term="区域名称">{{queryUserDetailInfoById.userAreaName}}</detail-list-item>
                <detail-list-item term="用户地址">{{queryUserDetailInfoById.userAddr}}</detail-list-item> -->
                <detail-list-item :term="$t('表安装地址')">{{queryUserDetailInfoById.userMeterAddr}}</detail-list-item>
                <detail-list-item :term="$t('手机号码')">{{queryUserDetailInfoById.userPhone}}</detail-list-item>
                <detail-list-item :term="$t('身份证号')">{{queryUserDetailInfoById.userIdNumber}}</detail-list-item>
                <detail-list-item :term="$t('身份类型')">{{queryUserDetailInfoById.userIdType== 1?$t('自然人'): $t('企业')}}</detail-list-item>
                <detail-list-item :term="$t('建档日期')">{{queryUserDetailInfoById.createTime}}</detail-list-item>
                <detail-list-item :term="$t('是否制卡')" v-if="model.meterType == 'WN100'">
                  {{queryUserDetailInfoById.userHasCard== 1?$t('已制卡'): $t('未制卡')}}</detail-list-item>
                <detail-list-item :term="$t('激活时间')">{{queryUserDetailInfoById.userActivateTime}}</detail-list-item>
                <detail-list-item :term="$t('激活人')">{{queryUserDetailInfoById.userActivateBy}}</detail-list-item>
                <detail-list-item :term="$t('是否整数计费')">{{queryUserDetailInfoById.isIntegerBilling==1?$t('是'):$t('否')}}</detail-list-item>
                <detail-list-item :term="$t('是否人证采集')">{{queryUserDetailInfoById.isCertified==1?$t('是'):$t('否')}}</detail-list-item>
                <detail-list-item :term="$t('用户地址')" :itemCol="1">{{queryUserDetailInfoById.userAreaName&&queryUserDetailInfoById.userAreaName.slice(queryUserDetailInfoById.userAreaName.indexOf('-')+1,queryUserDetailInfoById.userAreaName.length)+'-'+queryUserDetailInfoById.userAddr}}</detail-list-item>
              </detail-list>
              <a-form-model-item :label="$t('用水协议:')" class="notcolor">
                <JUpload v-model="fileList1" :buttonVisible="false"/>
              </a-form-model-item>
              <a-form-model-item :label="$t('协议签名')" class="notcolor">
                <j-image-upload class="avatar-uploader" :text="$t('上传')" :isMultiple="true" v-model="queryUserDetailInfoById.userAgreementSignature" :disabled="true"></j-image-upload>
              </a-form-model-item>
              <a-form-model-item :label="$t('用户资料:')" class="notcolor">
                <j-image-upload class="avatar-uploader" :text="$t('上传')" :isMultiple="true" v-model="fileList2" :disabled="true"></j-image-upload>
              </a-form-model-item>
              <a-divider orientation="left" v-if="queryUserDetailInfoById.userState==1">
                {{ $t('实时账户信息') }}
              </a-divider>
              <detail-list v-if="this.queryUserDetailInfoById.userState==1">
                <detail-list-item :term="$t('当前余额(元)')">{{this.queryUserDetailInfoById.userAccountNum}}</detail-list-item>
                <detail-list-item :term="$t('结算累计流量(m³)')">{{this.queryUserDetailInfoById.userCalNum}}</detail-list-item>
                <detail-list-item :term="$t('充值次数')">{{this.queryUserDetailInfoById.userPayTimes}}</detail-list-item>
                <!--
              <detail-list-item term="价格名称">{{this.queryUserDetailInfoById.wtName}}</detail-list-item>
              <detail-list-item term="合计单价(元)">{{this.queryUserDetailInfoById.wtTotalPrice}}</detail-list-item>
              -->
                <detail-list-item :term="$t('价格信息')">
                  <template
                    v-if="this.queryUserDetailInfoById.wtTotalPrice==null||this.queryUserDetailInfoById.wtTotalPrice==''">
                    --
                  </template>
                  <template v-else>
                    {{this.queryUserDetailInfoById.wtName+'('+this.queryUserDetailInfoById.wtTotalPrice+$t('元')+')'}}
                  </template>
                </detail-list-item>
                <detail-list-item :term="$t('开始计费读数(m³)')">{{this.queryUserDetailInfoById.userStartCalNum}}</detail-list-item>
                <detail-list-item :term="$t('最后一次更新日期')">{{this.queryUserDetailInfoById.userAccounyUpdateTime}}
                </detail-list-item>
              </detail-list>
              <a-divider orientation="left" v-if="this.queryUserDetailInfoById.userState==1">
                {{ $t('表具最新信息') }}
              </a-divider>
              <detail-list>
                <detail-list-item :term="$t('最后上报日期')">{{this.queryUserDetailInfoById.meterUpDataTime}}</detail-list-item>
                <detail-list-item :term="$t('最后上报读数(m³)')">{{this.queryUserDetailInfoById.meterTotalUse}}</detail-list-item>
                <detail-list-item :term="$t('表编号')">{{this.queryUserDetailInfoById.meterId}}</detail-list-item>
                <detail-list-item :term="$t('电池状态')">
                  {{this.queryUserDetailInfoById.meterBatteryStatus==0?$t("正常"):this.queryUserDetailInfoById.meterBatteryStatus==1?$t("欠压"):''}}
                </detail-list-item>
                <detail-list-item :term="$t('阀门状态')">{{Mn100FkStatusObj[this.queryUserDetailInfoById.meterValveStatus]}}
                </detail-list-item>
              </detail-list>
            </div>
          </a-tab-pane>
          <a-tab-pane key="2" :tab="$t('交易记录')">
            <div class="form-contain">
              <div class="table-page-search-wrapper">
                <a-form layout="inline" @keyup.enter.native="searchQuery">
                  <a-row :gutter="24">
                    <a-col :xl="12" :lg="7" :md="8" :sm="24">
                      <a-form-item :label="$t('操作类型')">
                        <a-select mode="multiple" v-model="genre" style="width: 100%" :placeholder="$t('请选择操作类型')"
                          :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}"
                          @change="handleChange">
                          <a-select-option v-for="(item,value) in payTypeObj" :value="value" :key="value">
                            {{item}}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :xl="8" :lg="7" :md="8" :sm="24">
                      <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                        <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                        <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}
                        </a-button>
                      </span>
                    </a-col>
                  </a-row>
                </a-form>
              </div>
              <a-table :columns="PaymentRecords" :data-source="UserPayRecord" :scroll="{x:true}" rowKey='id'
                size="middle" :pagination="ipagination" @change="handleTableChange" class="j-table-force-nowrap">
              </a-table>
            </div>
          </a-tab-pane>
          <a-tab-pane key="3" :tab="$t('上报数据')">
            <div class="form-contain">
              <a-table :columns="ReportedData" :data-source="UpDataRecord" :scroll="{x:true}" rowKey='id' size="middle"
                :pagination="ipaginationreported" @change="handleTableChangereported" class="j-table-force-nowrap">
                <span slot="action" slot-scope="text, record">
                  <a @click="handleParticulars(record)">{{ $t('详情') }}</a>
                </span>
              </a-table>
            </div>
          </a-tab-pane>
          <a-tab-pane key="4" :tab="$t('日用量报表')">
            <div class="form-contain">
              <a-button type="primary" icon="download" style="margin-bottom: 8px" @click="handleExportDayUse($t('日用量报表'))">{{ $t('导出') }}</a-button>
              <a-table :columns="DailyStatement" :data-source="UserWaterReportDay" :scroll="{x:true}" rowKey='id'
                size="middle" :pagination="ipaginationdosage" @change="handleTableChangedosage"
                class="j-table-force-nowrap">
              </a-table>
            </div>
          </a-tab-pane>
          <a-tab-pane key="5" :tab="$t('命令管理')">
            <div class="form-contain">
              <a-table :columns="OrderManagement" :data-source="commandlist" :scroll="{x:true}" rowKey='id'
                size="middle" :pagination="ipaginationmanagement" @change="handleTableChanmanagement"
                class="j-table-force-nowrap">
                <span slot="action" slot-scope="text, record">
                  <a @click="record.meterType=='80'?handleDetail(record):handleDetails(record)">{{ $t('详情') }}</a>
                </span>
              </a-table>
            </div>
          </a-tab-pane>
          <a-tab-pane key="6" :tab="$t('调价记录')">
            <div class="form-contain">
              <a-table :columns="priceChangeColumn" :data-source="priceChangeDataSource" :scroll="{x:true}" rowKey='id'
                size="middle" :pagination="ipaginationPriceChange" @change="handleTableChangePriceChange"
                class="j-table-force-nowrap">
              </a-table>
            </div>
          </a-tab-pane>
        </a-tabs>
        <meter-up-data-modal ref="upDataModal" @ok="upDataModalOk"></meter-up-data-modal>
        <partCommand-old-modal ref="modalOldForm" @ok="modalOldForm"></partCommand-old-modal>
        <partCommand-modal ref="modalForm" @ok="modalFormOk"></partCommand-modal>
        <meter-us-up-data-modal ref="usUpDataModal" @ok="upDataModalOk"></meter-us-up-data-modal>
        <meter-elef-up-data-record-modal ref="elefModalForm" @ok="upDataModalOk"></meter-elef-up-data-record-modal>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>
  import {
    getAction,
    downFile
  } from '@/api/manage'
  import {
    listSize
  } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import {
    queryAreaTreeList
  } from '@/api/api'
  import {
    isUndefined,
    isNull,
    isUndefinedAndNull
  } from '@/utils/validate'
  import DetailList from '@/components/tools/DetailList'
  import PartCommandOldModal from '../../part/modules/PartCommandOldModal'
  import PartCommandModal from '../../part/modules/PartCommandModal'
  import MeterUpDataModal from '../../InternetDeviceManagement/modules/MeterUpDataModal'
  import MeterUsUpDataModal from '../../InternetDeviceManagement/modules/MeterUsUpDataModal'
  import MeterElefUpDataRecordModal from '../../InternetDeviceManagement/modules/MeterElefUpDataRecordModal'
  import {
    filterObj
  } from '@/utils/util'
  import {
    dataFlagObj,
    netTypeObj,
    reportStatusObj,
    Mn100FkStatusObj,
    SendWayObj
  } from '@/utils/constants/protocolConstant'
  import {
    payWayObj,
    payTypeObj,
    meterTypeObj
  } from '@/utils/constants/commonConstant'
  import JImageUpload from '@/components/jeecg/JImageUpload.vue'
  import JUpload from '@/components/jeecg/JUpload'
import { log } from 'mathjs'

  const DetailListItem = DetailList.Item
  export default {
    name: 'MeterUserinfoForm',
    components: {
      JFormContainer,
      DetailList,
      DetailListItem,
      PartCommandOldModal,
      PartCommandModal,
      MeterUpDataModal,
      MeterUsUpDataModal,
      MeterElefUpDataRecordModal,
      JImageUpload,
      JUpload
    },
    data() {
      return {
        Mn100FkStatusObj,
        meterTypeObj,
        payTypeObj,
        seen: false,
        treeData: [],
        genre: [],
        condition: false,
        activeKey: '1',
        defaultkey: '',
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: {
            span: 24
          },
          sm: {
            span: 5
          },
        },
        wrapperCol: {
          xs: {
            span: 24
          },
          sm: {
            span: 16
          },
        },
        ipagination: {
          current: 1,
          pageSize: 8,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " " + this.$t('共{total}条', { total: total })
          },
          total: 0
        },
        ipaginationreported: {
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " " + this.$t('共{total}条', { total: total })
          },
          total: 0
        },
        ipaginationdosage: {
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " " + this.$t('共{total}条', { total: total })
          },
          total: 0
        },
        ipaginationmanagement: {
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " " + this.$t('共{total}条', { total: total })
          },
          total: 0
        },
        ipaginationPriceChange: {
          current: 1,
          pageSize: 8,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " " + this.$t('共{total}条', { total: total })
          },
          total: 0
        },
        confirmLoading: false,
        UserPayRecord: [],
        UpDataRecord: [],
        UserWaterReportDay: [],
        commandlist: [],
        priceChangeDataSource: [],
        queryUserDetailInfoById: [],
        url: {
          add: "/jeecg-charge/meter/meterUserinfo/add",
          edit: "/jeecg-charge/meter/meterUserinfo/edit",
          queryById: "/jeecg-charge/meter/meterUserinfo/queryById",
          list: "/jeecg-charge/meter/meterUserPayRecord/list", //缴费记录
          UpDataRecord: "/jeecg-charge/meter/meterUpDataRecord/list", //上报数据
          UserWaterReportDay: "/jeecg-charge/meter/meterUserWaterReportDay/list", //日用量报表详情查询
          exportDayUseXlsUrl: "/jeecg-charge/meter/meterUserWaterReportDay/exportXlsForDayUseSumList", //日用量报表导出
          commandlist: "/jeecg-charge/meter/command/list", //命令管理
          queryUserDetailInfoById: '/jeecg-charge/meter/meterUserinfo/queryUserDetailInfoById', //用户详情
          priceChangelist: '/jeecg-charge/meter/meterPriceChangeRecord/list'
        },
        fileList1: [],
        fileList2: ''
      }
    },
    computed: {
      PaymentRecords() {
        return [{
          title: this.$t('表编号'),
          dataIndex: 'meterId',
          align: "center",
        }, {
          title: this.$t('用户姓名'),
          dataIndex: 'userName',
          align: "center",
        }, {
          title: this.$t('购买金额(元)'),
          dataIndex: 'userPayAccountNum',
          align: "center",
          customRender: (t, r, index) => {
            if (!isUndefined(r.userAccountPayType) && [2, 4, 6].includes(r.userAccountPayType)) {
              return '-' + t
            }
            return t
          }
        }, {
          title: this.$t('价格名称'),
          dataIndex: 'userPriceName',
          align: "center",
        }, {
          title: this.$t('购买量(吨)'),
          align: "center",
          dataIndex: 'payWaterNum',
          customRender: (t, r, index) => {
            if (isUndefinedAndNull(t)) {
              return '--'
            }
            if (!isUndefined(r.userAccountPayType) && [2, 4, 6].includes(r.userAccountPayType)) {
              return '-' + t
            }
            return t
          }
        }, {
          title: this.$t('交易方式'),
          dataIndex: 'payWay',
          align: "center",
          customRender: (t, r, index) => {
            if (isUndefined(payWayObj[t])) {
              return this.$t("其他")
            }
            return this.$t(payWayObj[t])
          }
        }, {
          title: this.$t('订单号'),
          dataIndex: 'payOrderId',
          align: "center",
        }, {
          title: this.$t('操作类型'),
          dataIndex: 'userAccountPayType',
          align: "center",
          customRender: (t, r, index) => {
            if (isUndefined(payTypeObj[t])) {
              return this.$t("其他")
            }
            return this.$t(payTypeObj[t])
          }
        }, {
          title: this.$t('创建人'),
          dataIndex: 'createBy',
          align: "center",
        }, {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          align: "center",
        }]
      },
      ReportedData() {
        return [{
            title: this.$t('用户编号'),
            align: "center",
            dataIndex: 'userId',
            width: 150,
            ellipsis: true
          }, {
            title: this.$t('用户姓名'),
            align: "center",
            dataIndex: 'userName',
            width: 150,
            ellipsis: true
          }, {
            title: this.$t('用户地址'),
            align: "center",
            dataIndex: 'userAddr',
            width: 150,
            ellipsis: true,
            customRender: (t, r, index) => {
              if(r.userAreaName){
                let i = r.userAreaName.indexOf('-');
                return r.userAreaName.slice(i+1,r.userAreaName.length)+'-'+t;
              }else{
                return t
              }
            },
          }, {
            title: this.$t('表编号'),
            align: "center",
            dataIndex: 'meterId',
            width: 150,
            ellipsis: true
          },
          {
            title: this.$t('表类型'),
            align: "center",
            dataIndex: 'mtName',
            width: 100,
            ellipsis: true
          },
          {
            title: this.$t('表端时间'),
            align: "center",
            dataIndex: 'meterTime',
            width: 150,
            ellipsis: true
          }, {
            title: this.$t('上报时间'),
            align: "center",
            dataIndex: 'sysTime',
            width: 150,
            ellipsis: true
          }, {
            title: this.$t('阀门是否故障'),
            align: "center",
            dataIndex: 'meterValveFault',
            customRender: (t, r, index) => {
              let data = {
                "0": this.$t("正常"),
                "1": this.$t("故障")
              }
              if (isUndefined(data[t])) {
                return this.$t("其他")
              }
              return data[t]
            },
            width: 100,
            ellipsis: true
          },
          {
            title: this.$t('阀门状态'),
            align: "center",
            dataIndex: 'meterValveStatus',
            customRender: (t, r, index) => {
              let data = Mn100FkStatusObj;
              if (isUndefined(data[t])) {
                return this.$t('未知');
              }
              return this.$t(data[t])
            },
            width: 100,
            ellipsis: true
          },
          {
            title: this.$t('上报累计流量(m³)'),
            align: "center",
            dataIndex: 'meterTotalUse',
            width: 150,
            ellipsis: true
          },
          {
            title: this.$t('电池电压(V)'),
            align: "center",
            dataIndex: 'meterBatteryVoltage',
            width: 100,
            ellipsis: true
          },
          {
            title: this.$t('日冻结数据'),
            align: "center",
            dataIndex: 'meterDayUse',
            customRender: (t, r, index) => {
              if (t < 0) {
                return '--';
              }
              return t
            },
            width: 100,
            ellipsis: true
          },
          {
            title: this.$t('上报方式'),
            align: "center",
            dataIndex: 'meterUpWay',
            customRender: (t, r, index) => {
              let data = SendWayObj
              if (isUndefined(data[t])) {
                return this.$t("其他")
              }
              return this.$t(data[t])
            },
            width: 100,
            ellipsis: true
          },
          {
            title: this.$t('运营商'),
            align: "center",
            dataIndex: 'meterIotType',
            customRender: (t, r, index) => {
              let data = netTypeObj
              if (isUndefined(data[t])) {
                return this.$t("其他")
              }
              return this.$t(data[t])
            },
            width: 100,
            ellipsis: true
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 100,
            scopedSlots: {
              customRender: 'action'
            }
          }
        ]
      },
      DailyStatement() {
        return [{
            title: this.$t('用户编号'),
            align: "center",
            dataIndex: 'userId'
          }, {
            title: this.$t('表编号'),
            align: "center",
            dataIndex: 'meterId'
          }, {
            title: this.$t('用户姓名'),
            align: "center",
            dataIndex: 'userName'
          }, {
            title: this.$t('用户电话'),
            align: "center",
            dataIndex: 'userPhone'
          }, {
            title: this.$t('用户地址'),
            align: "center",
            dataIndex: 'userAddr',
            customRender: (t, r, index) => {
              if(r.userAreaName){
                let i = r.userAreaName.indexOf('-');
                return r.userAreaName.slice(i+1,r.userAreaName.length)+'-'+t;
              }else{
                return t
              }
            },
          }, {
            title: this.$t('日用量(m³)'),
            align: "center",
            dataIndex: 'dayUse'
          },
          {
            title: this.$t('报表日期'),
            align: "center",
            dataIndex: 'reportDate'
          }
        ]
      },
      OrderManagement() {
        return [{
          title: this.$t('用户编号'),
          align: "center",
          dataIndex: 'userId'
        }, {
          title: this.$t('用户姓名'),
          align: "center",
          dataIndex: 'userName'
        }, {
          title: this.$t('表编号'),
          align: "center",
          dataIndex: 'meterId'
        }, {
          title: this.$t('表安装地址'),
          align: "center",
          dataIndex: 'userMeterAddr'
        }, {
          title: this.$t('表类型'),
          align: "center",
          dataIndex: 'mtName'
        }, {
          title: this.$t('命令标识'),
          align: "center",
          dataIndex: 'cmd',
          customRender: (text) => {
            return this.$t(dataFlagObj[text])
          }
        }, {
          title: this.$t('命令ID'),
          align: "center",
          dataIndex: 'commandId'
        }, {
          title: this.$t('通讯状态'),
          align: "center",
          dataIndex: 'status',
          customRender: (t, r, index) => {
            let data = reportStatusObj
            if (isUndefined(data[t])) {
              return this.$t("其他")
            }
            return this.$t(data[t])
          }
        }, {
          title: this.$t('发送时间'),
          align: "center",
          dataIndex: 'sendTime'
        }, {
          title: this.$t('接收回应时间'),
          align: "center",
          dataIndex: 'receiveTime'
        }, {
          title: this.$t('操作'),
          dataIndex: 'action',
          align: "center",
          fixed: "right",
          width: 70,
          scopedSlots: {
            customRender: 'action'
          }
        }]
      },
      priceChangeColumn() {
        return [{
            title: this.$t('表编号'),
            align: "center",
            dataIndex: 'meterId'
          },
          {
            title: this.$t('用户编号'),
            align: "center",
            dataIndex: 'userId'
          },
          {
            title: this.$t('用户名称'),
            align: "center",
            dataIndex: 'userName'
          },
          {
            title: this.$t('旧价格信息'),
            align: "center",
            dataIndex: 'oldPrice',
            customRender: (t, r, index) => {
              if (isNull(r.oldPriceWtTotalPrice) || r.oldPriceWtTotalPrice == '') {
                return "--"
              }
              return r.oldPriceWtName + '(' + r.oldPriceWtTotalPrice + this.$t('元') + ')'
            }
          },
          {
            title: this.$t('新价格信息'),
            align: "center",
            dataIndex: 'newPrice',
            customRender: (t, r, index) => {
              if (isNull(r.newPriceWtTotalPrice) || r.newPriceWtTotalPrice == '') {
                return "--"
              }
              return r.newPriceWtName + '(' + r.newPriceWtTotalPrice + this.$t('元') + ')'
            }
          },
          {
            title: this.$t('变更方式'),
            align: "center",
            dataIndex: 'changeWay',
            customRender: (t, r, index) => {
              let data = {
                1: this.$t('立即结算'),
                2: this.$t('扣完再启用新价格')
              }
              if (isUndefined(data[t])) {
                return this.$t("其他")
              }
              return data[t]
            }
          },
          {
            title: this.$t('新价格启用日期'),
            align: "center",
            dataIndex: 'startDate'
          },
          {
            title: this.$t('创建时间'),
            align: "center",
            dataIndex: 'createTime',
          }, {
            title: this.$t('创建人'),
            align: "center",
            dataIndex: 'createBy'
          }
        ]
      },
      validatorRules() {
        return {
          meterId: { //表编号
            rules: [{
                required: true,
                len: 14,
                message: this.$t('请输入表编号!')
              },
              {
                validator: this.validatePlanName
              },
            ]
          },
          userAreaId: { // 区域id
            rules: [{
              required: true,
              message: this.$t('请输入用户区域id！')
            }, ]
          },
          userPriceCode: { //价格名称
            rules: [{
              required: true,
              message: this.$t('请选择价格编码！')
            }, ]
          },
        }
      },
      formDisabled() {
        if (this.formBpm === true) {
          if (this.formData.disabled === false) {
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton() {
        if (this.formBpm === true) {
          if (this.formData.disabled === false) {
            return true
          }
        }
        return false
      }
    },
    created() {

    },
    methods: {
      handleChange(value) {
        this.genre.type = value + '';
        console.log(this.genre.type + '');
        console.log(`selected ${value}`);
      },
      getQueryParams() {
        //获取查询条件
        let sqp = {}
        if (this.superQueryParams) {
          sqp['superQueryParams'] = encodeURI(this.superQueryParams)
          sqp['superQueryMatchType'] = this.superQueryMatchType
        }
        var param = Object.assign(sqp, this.queryParam, this.isorter, this.filters);
        param.pageNo = this.ipagination.current;
        param.pageSize = this.ipagination.pageSize;
        return filterObj(param);
      },
      loadData(arg) {
        console.log(arg);
        if (!this.url.list) {
          this.$message.error(this.$t("请设置url.list属性!"))
          return
        }
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        var params = this.getQueryParams(); //查询条件
        params.userAccountPayType = this.genre.type;
        params.userKeyId = this.model.id;
        console.log(params);
        this.loading = true;
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            this.UserPayRecord = res.result.records;
            this.ipagination.total = res.result.total;
          }
          if (res.code === 510) {
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },
      searchQuery() {
        this.loadData(1);
      },
      searchReset() {
        this.genre = [];
        this.queryParam = {};
        this.loadData(1);
      },
      queryUserDetailInfo() { //用户详情
        var params = {};
        params.id = this.model.id;
        console.log(params);
        this.loading = true;
        getAction(this.url.queryUserDetailInfoById, params).then((res) => {
          if (res.success) {
            this.queryUserDetailInfoById = res.result;
            console.log(this.queryUserDetailInfoById);
          }
          this.loading = false;
        })
      },
      queryUpDataRecord(arg) { //上报数据
        console.log(arg);
        if (arg === 1) {
          this.ipaginationreported.current = 1;
        }
        var params = {};
        params.pageNo = this.ipaginationreported.current;
        params.pageSize = this.ipaginationreported.pageSize;
        params.userId = this.model.userId;
        console.log(params);
        this.loading = true;
        getAction(this.url.UpDataRecord, params).then((res) => {
          if (res.success) {
            this.UpDataRecord = res.result.records;
            this.ipaginationreported.total = res.result.total;
            console.log(this.UpDataRecord);
          }
          this.loading = false;
        })
      },
      queryUserWaterReportDay(arg) { //日用量报表
        console.log(arg);
        if (arg === 1) {
          this.ipaginationdosage.current = 1;
        }
        let params = {}
        params.pageNo = this.ipaginationdosage.current;
        params.pageSize = this.ipaginationdosage.pageSize;
        params.userKeyId = this.model.id;
        console.log(params);
        this.loading = true;
        getAction(this.url.UserWaterReportDay, params).then((res) => {
          if (res.success) {
            this.UserWaterReportDay = res.result.records;
            this.ipaginationdosage.total = res.result.total;
            console.log(this.UserWaterReportDay);
          }
          this.loading = false;
        })
      },
      handleExportDayUse(fileName) { //日用量报表导出
        if (!fileName || typeof fileName !== 'string') {
          fileName = this.$t('导出文件')
        }
        // 导出范围与列表查询保持一致：按当前用户 userKeyId 过滤
        let param = { userKeyId: this.model.id }
        downFile(this.url.exportDayUseXlsUrl, param).then((data) => {
          if (!data) {
            this.$message.warning(this.$t('文件下载失败'))
            return
          }
          if (typeof window.navigator.msSaveBlob !== 'undefined') {
            window.navigator.msSaveBlob(new Blob([data], { type: 'application/vnd.ms-excel' }), fileName + '.xls')
          } else {
            let url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel' }))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', fileName + '.xls')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
          }
        })
      },
      querycommandlist(arg) { //命令管理
        if (arg === 1) {
          this.ipaginationmanagement.current = 1;
        }
        let params = {}
        params.pageNo = this.ipaginationmanagement.current;
        params.pageSize = this.ipaginationmanagement.pageSize;
        params.userId = this.model.userId;
        console.log(params);
        this.loading = true;
        getAction(this.url.commandlist, params).then((res) => {
          if (res.success) {
            this.commandlist = res.result.records;
            this.ipaginationmanagement.total = res.result.total;
            console.log(this.commandlist);
          }
          this.loading = false;
        })
      },
      queryPriceChangeList(arg) {
        if (arg === 1) {
          this.ipaginationPriceChange.current = 1;
        }
        let params = {}
        params.pageNo = this.ipaginationPriceChange.current;
        params.pageSize = this.ipaginationPriceChange.pageSize;
        params.userKeyId = this.model.id;
        console.log(params);
        this.loading = true;
        getAction(this.url.priceChangelist, params).then((res) => {
          if (res.success) {
            this.priceChangeDataSource = res.result.records;
            this.ipaginationPriceChange.total = res.result.total;
          }
          this.loading = false;
        })
      },
      handleTableChange(pagination, filters, sorter) {
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
        this.ipagination = pagination;
        this.loadData();
      },
      handleTableChangereported(paginationreported, filters, sorter) {
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
        this.ipaginationreported = paginationreported;
        this.queryUpDataRecord();
      },
      handleTableChangedosage(paginationdosage, filters, sorter) {
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
        this.ipaginationdosage = paginationdosage;
        this.queryUserWaterReportDay()
      },
      handleTableChanmanagement(paginationdosagemanagement, filters, sorter) {
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
        this.ipaginationmanagement = paginationdosagemanagement;
        this.querycommandlist()
      },
      handleTableChangePriceChange(paginationPriceChange, filters, sorter) {
        this.ipaginationPriceChange = paginationPriceChange;
        this.queryPriceChangeList()
      },
      loadTreeData() {
        console.log("查询区域")
        var that = this;
        queryAreaTreeList().then((res) => {
          if (res.success) {
            //部门全选后，再添加部门，选中数量增多
            that.treeData = []
            for (let i = 0; i < res.result.length; i++) {
              let temp = res.result[i]
              that.treeData.push(temp)
            }
          }
        })
      },
      callback(key) {
        console.log(key);
        if (this.activeKey == 1) {
          this.queryUserDetailInfo();
        } else if (this.activeKey == 2) {
          this.genre = [];
          this.loadData(1);
        } else if (this.activeKey == 3) {
          this.queryUpDataRecord(1);
        } else if (this.activeKey == 4) {
          this.queryUserWaterReportDay(1);
        } else if (this.activeKey == 5) {
          this.querycommandlist(1);
        } else if (this.activeKey == 6) {
          this.queryPriceChangeList(1)
        }
      },
      handleDetails(record) {
        this.$refs.modalOldForm.edit(record);
        this.$refs.modalOldForm.title = this.$t("详情");
        this.$refs.modalOldForm.disableSubmit = true;
      },
      handleDetail(record) {
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.title = this.$t("详情");
        this.$refs.modalForm.disableSubmit = true;
      },
      handleParticulars(record) {
        if (record.meterType == '15') {
          this.$refs.usUpDataModal.edit(record);
          this.$refs.usUpDataModal.title = this.$t("详情");
          this.$refs.usUpDataModal.disableSubmit = true;
        } else if(record.meterType == 'Y14-4G'){
          // 迅尔电磁流量计
          this.$refs.elefModalForm.edit(record);
          this.$refs.elefModalForm.title = this.$t("详情");
          this.$refs.elefModalForm.disableSubmit = true;
        } else {
          this.$refs.upDataModal.edit(record);
          this.$refs.upDataModal.title = this.$t("详情");
          this.$refs.upDataModal.disableSubmit = true;
        }

      },
      modalOldForm() {},
      modalFormOk() {},
      upDataModalOk() {},
      add() {
        this.edit({});
      },
      edit(record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        if(this.model.userAgreementUrl) this.fileList1 = [this.model.userAgreementUrl];
        this.$set(this,'fileList2',this.model.userMessagePictureUrl || '')
        console.log("就当回复",this.fileList2);
        this.visible = true;
        this.loadTreeData();
        this.queryUserDetailInfo();
      },
      shut() { //关闭按钮
        this.activeKey = '1';
        this.genre = [];
        this.form.resetFields();
        console.log(this.activeKey);
      }
    },
  }
</script>
<style scoped>
  .ant-form-item>>>.ant-select {
    width: 100%;
  }

  .detail-list>>>.content {
    line-height: normal;
  }
  /deep/.notcolor .ant-form-item-label > label{
    color: #999999;
  }
</style>